/* ---------------------------------------------------------------------------
 * Cookie banner - French copy alignment
 *
 * WHY: Shopify renders the cookie banner from its own storefront-banner.js and
 * does not expose its strings through the Admin API, nor as a translatable
 * resource. The Admin editor only edits the EN copy. The French storefront is
 * the primary experience, so its banner paragraph is aligned here.
 *
 * SCOPE: replaces ONE text node - the banner's long paragraph. It never
 * touches buttons, links, categories, the consent logic, or any cookie value.
 *
 * LANGUAGE GUARD: runs only when the document language is French.
 *
 * REMOVE AT COMMERCIAL LAUNCH if Shopify then provides native FR copy.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  // 2026-10-04: the same sentence in every storefront language the Maison serves.
  var COPY = {
    fr: "Nous utilisons des cookies pour faire fonctionner le site et, "
      + "avec votre accord, am\u00e9liorer votre exp\u00e9rience. En savoir plus.",
    es: "Utilizamos cookies para que el sitio funcione y, con su consentimiento, "
      + "mejorar su experiencia. M\u00e1s informaci\u00f3n.",
    de: "Wir verwenden Cookies, damit die Website funktioniert, und mit Ihrer "
      + "Zustimmung, um Ihr Erlebnis zu verbessern. Mehr erfahren.",
    it: "Utilizziamo i cookie per far funzionare il sito e, con il suo consenso, "
      + "migliorare la sua esperienza. Scopri di pi\u00f9.",
    pt: "Utilizamos cookies para o site funcionar e, com o seu consentimento, "
      + "melhorar a sua experi\u00eancia. Saiba mais.",
    nl: "We gebruiken cookies om de website te laten werken en, met uw toestemming, "
      + "uw ervaring te verbeteren. Meer informatie."
  };
  var FR_COPY = COPY[(document.documentElement.lang || '').toLowerCase().split('-')[0]] || '';

  function isFrench() {
    return FR_COPY !== '';
  }

  function align(root) {
    var banner = root.querySelector('#shopify-pc__banner');
    if (!banner) return false;

    // the long paragraph carries its text directly (no shadow DOM)
    var paras = banner.querySelectorAll('p');
    for (var i = 0; i < paras.length; i++) {
      var p = paras[i];
      var own = '';
      for (var j = 0; j < p.childNodes.length; j++) {
        if (p.childNodes[j].nodeType === 3) own += p.childNodes[j].textContent;
      }
      // only the descriptive paragraph, never a short label
      if (own.trim().length < 60) continue;

      // replace just the leading text node, leaving any inline <a> untouched
      for (var k = 0; k < p.childNodes.length; k++) {
        var node = p.childNodes[k];
        if (node.nodeType !== 3) continue;
        if (node.textContent.trim().length < 60) continue;
        node.textContent = FR_COPY + ' ';
        return true;
      }
    }
    return false;
  }

  function start() {
    if (!isFrench()) return;
    if (align(document)) return;

    // the banner is injected after load: watch for it
    var mo = new MutationObserver(function () {
      if (align(document)) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
